import { Question } from './question';
/*{{imports}}*/

export class Script {
  static naviCode = new Map<number, Question>([
    /*{{questions}}*/
  ]);
}
